import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ align = 'left' }) => align};
  margin-bottom: 25px;

  ${media.md`
    flex-direction: row;
    align-items: flex-start;
    padding: 0 20px;
    justify-content: ${({ alignMd = 'left' }) => alignMd};
  `}
`;

export default Row;
